export default __webpack_public_path__ + "static/media/error.039bb2ad.svg";